module.exports = __webpack_public_path__ + "img/yz-tag.1b65c25c.svg";